import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Inertia',
    description: "Inertia turns the laws of physics into live, interactive 3D simulations you can push, pull and explore, right in your browser.",
    url: getOrigin()
}
